import { MainAppResource } from './base';

export default function UserInfo(token) {
  return MainAppResource(`accounts/auth/token/resource_owner?access_token=${token}`);
}
